import { render, staticRenderFns } from "./EditSubholdingMemoModal.vue?vue&type=template&id=73c981b4&"
import script from "./EditSubholdingMemoModal.vue?vue&type=script&lang=js&"
export * from "./EditSubholdingMemoModal.vue?vue&type=script&lang=js&"
import style0 from "./EditSubholdingMemoModal.vue?vue&type=style&index=0&id=73c981b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports